import { CheckoutActionTypes, CheckoutContextValue, PlaceOrderData } from "@swiggy-private/checkout-core";

import { EXPERIMENTS_VALUES } from "@payment-client/constants/Experiments";

export const handlePaymentFailure = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    err: any,
    placeOrderData: PlaceOrderData,
    setCheckoutState: CheckoutContextValue["setCheckoutState"],
): void => {
    const paymentFailureResponse = err?.data?.paymentFailureResponse;
    const isFallbackApiEnabled = err?.data?.xpData?.showPaymentFailureReasonHalfCard === "true";
    const autopayPaymentFailure = [
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.CONSENT,
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.SUBTLE_AUTOPLACE,
    ].includes(err?.data?.xpData?.autoPayVariant);

    if (autopayPaymentFailure) {
        setCheckoutState({
            type: CheckoutActionTypes.AUTOPAY_ELIGIBLE_PAYMENT_FAILED,
            payload: {
                paymentFailureResponse,
                placeOrderData,
                isFallbackApiEnabled: isFallbackApiEnabled,
                autoPayPaymentFailureVariant: err?.data?.xpData?.autoPayVariant,
            },
        });
    } else {
        setCheckoutState({
            type: CheckoutActionTypes.PAYMENT_FAILED,
            payload: {
                paymentFailureResponse,
                placeOrderData,
                isFallbackApiEnabled: isFallbackApiEnabled,
            },
        });
    }
};
